import './css/App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Authoring from './Authoring';
import Templating from './Templating';

window.onbeforeunload = (event) => {
  const e = event || window.event;
  // Cancel the event
  e.preventDefault();
  if (e) {
    e.returnValue = ''; // Legacy method for cross browser support
  }
  return ''; // Legacy method for cross browser support
};

function App(props) {
  return (
    <Router basename={'/app'}>
      <div>
        <Routes>
          <Route path = "/" element={<Authoring/>}/>
          <Route path = "/reuse" element={<Templating/>}/>
        </Routes>
      </div>
    </Router>
  )
}

export default App;
